import type { FaireProductEntity } from "../../entity_types/product";

export const p_43ydcutjve: FaireProductEntity = {
  token: "p_43ydcutjve",
  type: "product",
  name: "Freeze Dried Peach Slices",
  brandToken: "b_d7mymnraud",
  brandName: "Big Green Organic Food",
  imageUrl:
    "https://cdn.faire.com/fastly/2deb1b2429178a2b89adc0ec48b0a6432e72f9472eb9b13c117698f454c4d195.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d9024cc3dd7da622ed9522166f942ec8ebeb86f35af678eca2c12736385b5c8.jpeg",
    "https://cdn.faire.com/fastly/c37e7d005d004cb722baf4b19e68f25f653b053f7b783883fe0435dcba4f7a1c.png",
  ],
  priceDollars: 1.94,
  description:
    "Freeze Dried Peach Slices\n\nDisclaimer: WARNING: This product can expose you to chemicals including arsenic, which is known to the State of California to cause cancer. For more information go to www.P65Warnings.ca.gov.",
  tags: [],
  msrpDollars: 2.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:07.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
